import { Stage, Container } from "@pixi/react";
import { useState, useEffect, useRef } from "react";
import { dimensionType } from "../../@types";
import AppStage from "./AppStage";
import { useAviator } from "../../store/aviator";
import { GameStages, useSocket } from "../../providers/SocketProvider";

const PIXIComponent = ({
  pixiDimension,
  curPayout,
  trigParachute,
}: {
  pixiDimension: dimensionType;
  curPayout: number;
  trigParachute: { uniqId: number; isMe: boolean };
}) => {
  const { aviatorState } = useAviator();
  const { gameData } = useSocket();
  const [scale, setScale] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [actualDimension, setActualDimension] = useState(pixiDimension);

  // Measure actual container size
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setActualDimension({
          width: rect.width || pixiDimension.width,
          height: rect.height || pixiDimension.height,
        });
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    // Also update after a short delay for initial render
    const timer = setTimeout(updateSize, 100);

    return () => {
      window.removeEventListener("resize", updateSize);
      clearTimeout(timer);
    };
  }, [pixiDimension]);

  useEffect(() => {
    // Scale to fill the canvas height completely (no black gap at bottom)
    const scaleY = actualDimension.height / aviatorState.dimension.height;
    setScale(scaleY);
  }, [actualDimension, aviatorState.dimension]);

  return (
    <div
      ref={containerRef}
      className="overflow-hidden w-full h-full"
      style={{
        borderBottomLeftRadius: "20px",
        borderBottomRightRadius: "20px",
        borderTopRightRadius: "20px",
        borderTopLeftRadius: "20px",
      }}
    >
      <Stage
        width={actualDimension.width}
        height={actualDimension.height}
        options={{ antialias: true, backgroundColor: 0x0a0a0a }}
      >
        <Container scale={scale}>
          <AppStage
            payout={curPayout}
            game_anim_status={gameData.status || GameStages.WAIT}
            dimension={aviatorState.dimension}
            pixiDimension={actualDimension}
          />
        </Container>
      </Stage>
    </div>
  );
};
export default PIXIComponent;
